const questions = [
  // 1 Слайд \\
  {
    questionText:
      "«ลูกชุบ» ขนมไทยโบราณขนาดเล็กที่มีลักษณะคล้ายผลไม้ ดูน่ารับประทาน รู้หรือไม่ว่าไส้ข้างในทำมาจากอะไร?",
    answerOptions: [
      {
        answerText: "มาร์ซิปัน",
        answerResult:
          "ขนม «ผลไม้จิ๋ว» เหล่านี้มีต้นกำเนิดมาจากขนมโปรตุเกสเมื่อ\u200Bศตวรรษที่ 16 เชฟชาวไทยได้ปรับสูตร โดยเปลี่ยนจากอัลมอนด์\u200Bมาเป็นถั่วเขียว กลายเป็นเอกลักษณ์แบบไทยที่ลงตัวมากขึ้น",
        result: false,
      },
      {
        answerText: "ถั่วเขียวบด",
        answerResult:
          "ขนม «ผลไม้จิ๋ว» เหล่านี้มีต้นกำเนิดมาจากขนมโปรตุเกสเมื่อ\u200Bศตวรรษที่ 16 เชฟชาวไทยได้ปรับสูตร โดยเปลี่ยนจากอัลมอนด์\u200Bมาเป็นถั่วเขียว กลายเป็นเอกลักษณ์แบบไทยที่ลงตัวมากขึ้น",
        result: true,
      },
      {
        answerText: "มันเทศ",
        answerResult:
          "ขนม «ผลไม้จิ๋ว» เหล่านี้มีต้นกำเนิดมาจากขนมโปรตุเกสเมื่อ\u200Bศตวรรษที่ 16 เชฟชาวไทยได้ปรับสูตร โดยเปลี่ยนจากอัลมอนด์\u200Bมาเป็นถั่วเขียว กลายเป็นเอกลักษณ์แบบไทยที่ลงตัวมากขึ้น",
        result: false,
      },
    ],
    image: "images/1.jpg",
  },

  // 2 слайд \\
  {
    questionText:
      "สีชมพูจากเย็นตาโฟที่ดูโดดเด่นเป็นเอกลักษณ์ รู้หรือไม่ว่ามาจากส่วนผสมใด?",
    answerOptions: [
      {
        answerText: "น้ำบีทรูท",
        answerResult:
          "ใช่แล้ว มันคือ «เต้าหู้ยี้» รสเปรี้ยวหวานเข้มข้นเป็นเอกลักษณ์ พร้อมสีชมพูที่เห็นเมื่อไหร่ก็จำได้ทันที แม้จะมองมาจากอีกฝั่งของโต๊ะก็ตาม",
        result: false,
      },
      {
        answerText: "เต้าหู้ยี้",
        answerResult:
          "ใช่แล้ว มันคือ «เต้าหู้ยี้» รสเปรี้ยวหวานเข้มข้นเป็นเอกลักษณ์ พร้อมสีชมพูที่เห็นเมื่อไหร่ก็จำได้ทันที แม้จะมองมาจากอีกฝั่งของโต๊ะก็ตาม",
        result: true,
      },
      {
        answerText: "กะปิ",
        answerResult:
          "ใช่แล้ว มันคือ «เต้าหู้ยี้» รสเปรี้ยวหวานเข้มข้นเป็นเอกลักษณ์ พร้อมสีชมพูที่เห็นเมื่อไหร่ก็จำได้ทันที แม้จะมองมาจากอีกฝั่งของโต๊ะก็ตาม",
        result: false,
      },
    ],
    image: "images/2.jpg",
  },

  // 3 слайд \\
  {
    questionText:
      "«Omakase» คำที่หลายคนคุ้นหู จริง ๆ แล้วคำนี้หมายความว่าอะไร?",
    answerOptions: [
      {
        answerText: "สดใหม่จากทะเล",
        answerResult:
          "«โอมากาเสะ» หมายถึง การมอบความไว้วางใจให้เชฟเป็นผู้รังสรรค์เมนู เหมือนกับ… ให้ Maxim รังสรรค์เรื่องการส่งของให้คุณ",
        result: false,
      },
      {
        answerText: "ให้เชฟเป็นผู้เลือกให้",
        answerResult:
          "«โอมากาเสะ» หมายถึง การมอบความไว้วางใจให้เชฟเป็นผู้รังสรรค์เมนู เหมือนกับ… ให้ Maxim รังสรรค์เรื่องการส่งของให้คุณ",
        result: true,
      },
      {
        answerText: "การรับประทานอาหารแบบเงียบ",
        answerResult:
          "«โอมากาเสะ» หมายถึง การมอบความไว้วางใจให้เชฟเป็นผู้รังสรรค์เมนู เหมือนกับ… ให้ Maxim รังสรรค์เรื่องการส่งของให้คุณ",
        result: false,
      },
    ],
    image: "images/3.jpg",
  },

  // 4 слайд \\
  {
    questionText:
      "«กิมจิชิแก» ซุปเกาหลีรสเข้มข้นที่ให้ความรู้สึกอบอุ่นในทุกคำ แล้วเคล็ดลับความอร่อยอยู่ที่อะไร?",
    answerOptions: [
      {
        answerText: "กิมจิหมัก",
        answerResult:
          "เชฟเกาหลียืนยันเลยว่า: ยิ่งหมักกิมจิไว้นานและเปรี้ยวมากเท่า\u200Bไหร่ รสชาติก็ยิ่งเข้มข้นมากขึ้นเท่านั้น ส่วนแบบใหม่ ๆ\u200B น่ะเหรอ ยังไม่ถึงรส",
        result: true,
      },
      {
        answerText: "น้ำตาล",
        answerResult:
          "เชฟเกาหลียืนยันเลยว่า: ยิ่งหมักกิมจิไว้นานและเปรี้ยวมากเท่า\u200Bไหร่ รสชาติก็ยิ่งเข้มข้นมากขึ้นเท่านั้น ส่วนแบบใหม่ ๆ\u200B น่ะเหรอ ยังไม่ถึงรส",
        result: false,
      },
      {
        answerText: "ผักกาดขาวสด",
        answerResult:
          "เชฟเกาหลียืนยันเลยว่า: ยิ่งหมักกิมจิไว้นานและเปรี้ยวมากเท่า\u200Bไหร่ รสชาติก็ยิ่งเข้มข้นมากขึ้นเท่านั้น ส่วนแบบใหม่ ๆ\u200B น่ะเหรอ ยังไม่ถึงรส",
        result: false,
      },
    ],
    image: "images/4.jpg",
  },

  // 5 слайд \\
  {
    questionText:
      "«ติ่มซำ» ของกินชิ้นเล็กที่อัดแน่นด้วยความอร่อย แล้วชื่อของมันมีความหมายว่าอะไรนะ?",
    answerOptions: [
      {
        answerText: "ตะกร้าเล็ก ๆ",
        answerResult:
          "«ติ่มซำ» มีความหมายตามตัวอักษรว่า «แตะที่หัวใจ» แล้วเหมือนว่า คุณก็ทำแบบนั้นกับเราไปเหมือนกันนะ เลื่อนลงไปรับโค้ดส่วนลดได้เลย",
        result: false,
      },
      {
        answerText: "แตะที่หัวใจ",
        answerResult:
          "«ติ่มซำ» มีความหมายตามตัวอักษรว่า «แตะที่หัวใจ» แล้วเหมือนว่า คุณก็ทำแบบนั้นกับเราไปเหมือนกันนะ เลื่อนลงไปรับโค้ดส่วนลดได้เลย",
        result: true,
      },
      {
        answerText: "อาหารเช้าของจักรพรรดิ",
        answerResult:
          "«ติ่มซำ» มีความหมายตามตัวอักษรว่า «แตะที่หัวใจ» แล้วเหมือนว่า คุณก็ทำแบบนั้นกับเราไปเหมือนกันนะ เลื่อนลงไปรับโค้ดส่วนลดได้เลย",
        result: false,
      },
    ],
    image: "images/5.jpg",
  },
];

export default questions;
